module.exports = __webpack_public_path__ + "static/media/ES.8b7943f1.jpg";